import React, {useEffect} from 'react';

declare const APP_VERSION: string;
declare const APPLETS_LIST: string;

export const AppRuntimeInitializer = () => {
  useEffect(() => {
    (window as any).version = APP_VERSION;
    (window as any).applets = APPLETS_LIST;
  }, []);

  return <meta name="ui-version" content={APP_VERSION} />;
};
